/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { DeviceModel } from "../../model/device";

export const selectIsTvDevice = (_state?: unknown): boolean => {
  return DeviceModel.isTvDevice();
};

/** True only on platforms with a cursor/pointer: browser and LG webOS. */
export const selectHasCaretPointerSupport = (_state?: unknown): boolean => {
  return DeviceModel.hasCaretPointerSupport();
};

export const selectIsMobileDevice = (_state?: unknown): boolean => {
  return DeviceModel.isMobileDevice();
};

/** True only for 2021 Samsung Tizen TVs (Tizen OS 6.0). */
export const selectIsSamsung2021Tv = (_state?: unknown): boolean => {
  return DeviceModel.isSamsung2021Tv();
};

export default {};
